<template>
  <div :title="live.title">
    <div class="live-item-hot">
      <div class="item-tag" :style="{ background: live.tag_info.color }">{{ live.tag_info.title }}</div>
      <div class="hot-live-item" :style="height" @click="enterRoom(live)">
        <img v-lazy="thumbImg" class="item-cover" />
      </div>
      <div class="hot-desc">
        <!-- <div class="desc-title">{{ live.anchor_name }} {{ live.title }} 猎鹰直播</div> -->
        <div class="desc-title">{{ live.title }}</div>
        <div class="desc-content">
          <img class="desc-logo" v-lazy="live.anchor_avatar" alt="" />
          <div class="user-name sl">
            {{ live.anchor_name }}
          </div>
          <div class="hot-content">
            <!-- <span class="icon font_family">&#xe631;</span> -->
            <img class="hot-icon" v-lazy="heatImg" />
            <span>{{ $bigNumber(live.hot) }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <TicketPayConfirm :ticket="live.ticket" :anchorId="live.anchorid" ref="ticket" /> -->
  </div>
</template>

<script>
// import TicketPayConfirm from "@/components/dialog/TicketPayConfirm";
import { mapState, mapMutations, mapActions } from "vuex";
import { enterRoom } from "@/util/enterRoomTicket";

export default {
  name: "live-item-hot2",
  components: {
    // TicketPayConfirm,
  },
  props: {
    live: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "live",
    },
    height: {
      type: String,
      default: "",
    },
  },
  created() {
    if (!this.live.tag_info) {
      this.live.tag_info = {};
    }
  },

  computed: {
    ...mapState(["userInfo", "appConfig"]),
    heatImg() {
      return require("./hot.png");
    },
    link() {
      return `/liveMatchesTwo/${this.type === "live" ? this.live.anchorid : this.live.id}`;
    },
    thumbImg() {
      return this.live.thumb_y || this.live.thumb || require("./default_live_bg.png");
    },
  },

  data() {
    return {
      images: require("./queshengye.jpg"),
    };
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    enterRoom,
    // JionRoom() {
    //   console.log(this.live, "live");
    //   if (this.live.ticket > 0 && this.live.ticket_paid === 2) {
    //     if (!this.userInfo.id) {
    //       this.toggleLogin();
    //       return;
    //     }
    //     this.$refs.ticket.open();
    //   } else {
    //     this.$router.push(`/liveMatchesTwo/${this.live.anchorid}`);
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.live-item-hot {
  background: #ffffff;
  // box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0.05rem;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  border-color: #eee;

  .item-tag {
    position: absolute;
    top: 0.04rem;
    right: 0.04rem;
    padding: 0.02rem 0.06rem;
    border-radius: 0.02rem;
    font-weight: 600;
    font-size: 0.14rem;
    color: #fff;
    z-index: 1;
  }

  &:hover {
    border-color: #02a8a2;

    .hot-live-item::before {
      content: "";
      width: 64px;
      height: 64px;
      display: block;
      position: absolute;
      left: 50%;
      top: 36%;
      transform: translateX(-50%);
      z-index: 2;
      background: url("./pause.png") no-repeat center center / contain !important;
      pointer-events: none;
    }

    .item-cover {
      transform: scale(1.1);
    }
  }

  .hot-live-item {
    display: block;
    height: 1.73rem;
    background-color: #fff;
    cursor: pointer;
    color: #333333;
    overflow: hidden;
    position: relative;

    .item-cover {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      transition: all 0.5s;
    }
  }

  .hot-desc {
    display: block;
    padding: 0.08rem 0.12rem;
    width: 100%;
    background-color: #ffffff;
    font-size: 0.14rem;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;

    .desc-title {
      height: 0.22rem;
      line-height: 0.22rem;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .desc-content {
      padding: 2px 0px;
      display: flex;
      flex-direction: row;
      align-items: center;

      img.desc-logo {
        background: rgba(0, 0, 0, 0.1);
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
      }

      .user-name {
        font-size: 0.12rem;
        padding: 0 5px;
        color: #999999;

        &.sl {
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .hot-content {
        flex: 1;
        text-align: right;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 0.12rem;
      }

      .hot-icon {
        margin-right: 0.03rem;
        height: 0.16rem;
        width: 0.16rem;
        padding: 0px 2px;
      }
    }
  }
}
</style>
